import { useState, useEffect, useContext } from 'react';

import { PracticeReseveContext } from '../../../../../../PracticeReseveContext';


// シチュエーションごと:発音コース
function PracticeReserveSituationCaseCategoryPronunciation(props: any) {

  const { title } = useContext(PracticeReseveContext);

  return (
    <li className="list-group-item text-center">
      <p>
        発音コース教材の{title}
        <br className="visible-xs" />
        ご購入後にご利用可能です
      </p>
      <a href="/lesson/pronunciation?day=1" className="btn btn-primary">
        発音コースのご購入はコチラ
      </a>
    </li>
  );
}
  
export default PracticeReserveSituationCaseCategoryPronunciation;